"use client"

import Script from "next/script"

const FRIENDLY_CAPTCHA_SITE_KEY = "FCMQMF2A9M34Q6HJ"
const FRIENDLY_CAPTCHA_PUZZLE_ENDPOINT = "https://eu-api.friendlycaptcha.eu/api/v1/puzzle"

export default function FriendlyCaptchaClient() {
  return (
    <>
      <Script
        type="module"
        src="https://unpkg.com/friendly-challenge@0.9.9/widget.module.min.js"
        strategy="afterInteractive"
      />
      <Script
        noModule={true}
        src="https://unpkg.com/friendly-challenge@0.9.9/widget.min.js"
        strategy="afterInteractive"
      />
      <div
        className="frc-captcha xl:col-span-2"
        data-sitekey={FRIENDLY_CAPTCHA_SITE_KEY}
        data-puzzle-endpoint={FRIENDLY_CAPTCHA_PUZZLE_ENDPOINT}
      />
    </>
  )
}
